import { render } from "./LaputaMomentList.vue?vue&type=template&id=762c8b1e&scoped=true"
const script = {}

import "./LaputaMomentList.vue?vue&type=style&index=0&id=762c8b1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762c8b1e"]])

export default __exports__